import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
	selector: 'tvsub-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss'],
	standalone: false
})
export class LogoutComponent implements OnInit {
	sessionExpired: boolean = false;
	signOutUrl: string;

	constructor(private route: ActivatedRoute) {
	}

	ngOnInit() {
		const uat = location.href.includes('test-') || location.href.includes('localhost');
		this.signOutUrl = `https://authenticatie${uat ? '-ti' : ''}.vlaanderen.be/op/v1/logout`;

		this.sessionExpired = this.route.snapshot.queryParamMap.get('session') === 'expired';
	}
}
